import { exportInstructions, exportWorkflowInstructions } from '../../generated/api/sdk.gen.js';
import type { InstructionExportBody } from '../../generated/api/types.gen.js';
import { unwrapGenerated } from './generated.js';

// ==========================================
// Workflow Instruction Export API
// ==========================================

export type ExportInstructionsOptions = InstructionExportBody;

export const workflowInstructionApi = {
  /** Export instructions (generic or with workflow context) */
  exportInstructions: (options: ExportInstructionsOptions) => unwrapGenerated(exportInstructions({ body: options })),

  /** Export instructions for a specific workflow (shorthand) */
  exportForWorkflow: (workflowId: string, options?: Partial<ExportInstructionsOptions>) =>
    unwrapGenerated(exportWorkflowInstructions({ path: { id: workflowId }, body: { scope: 'full', ...options } })),
};
